import { Component } from '@angular/core';
import { Calculation } from './calculation.model';
import { CalculationService } from './calculation.service';
import { UIRouter } from '@uirouter/angular';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';
import { priceType } from '../price/price.enum';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-calculation',
  templateUrl: './calculation.component.html'
})
export class CalculationComponent {
  public calculation = new Calculation();
  public priceListTypes = Object.keys(priceType).map((key) => priceType[key]);

  constructor(
    private calculationService: CalculationService,
    protected router: UIRouter,
    private toastr: ToastsManager,
    private translate: TranslateService,
  ) {}

  public save() {
    this.calculationService.add(this.calculation)
      .subscribe(
        (res) => {
          this.saveFileToDisk(res);
          this.router.stateService.go('calculation', this.router.stateService.params, { reload: true });
        },
        (err) => {
          if (err.error instanceof ArrayBuffer) {
            this.toastr.error(this.arrayBufferToString(err.error));
          } else {
            this.toastr.error(err.error);
          }
        }
      );
  }

  private saveFileToDisk(res: HttpResponse<ArrayBuffer>) {
    const blob = new Blob([res.body], { type: res.headers.get('content-type') });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = this.getFilenameFromDisposition(res.headers.get('Content-Disposition'));
    a.click();
  }

  public getCalculationSheet() {
    this.calculationService.getCalculationSheet()
      .subscribe(
        (res) => {
          this.saveFileToDisk(res);
        },
        (err) => {
          if (err.error instanceof ArrayBuffer) {
            this.toastr.error(this.arrayBufferToString(err.error));
          } else {
            this.toastr.error(err.error);
          }
        }
      );
  }

  private arrayBufferToString(buffer: ArrayBuffer): string {
    let result = '';
    const bytes = new Uint8Array(buffer);

    for (let i = 0; i < bytes.length; i++) {
      result += String.fromCharCode(bytes[i]);
    }

    return result;
  }

  public fileChange(evt) {
    this.calculation.setFile(evt.target.files);
  }

  public onPriceListTypeChange(event: any, value: string) {
    if (event.target.checked) {
      if (!this.calculation.priceListTypes.includes(value)) {
        this.calculation.priceListTypes.push(value);
      }
    } else {
      const index = this.calculation.priceListTypes.indexOf(value);
      if (index > -1) {
        this.calculation.priceListTypes.splice(index, 1);
      }
    }
  }

  private getFilenameFromDisposition(header: string | null): string | null {
    if (!header) {
      return null;
    }

    // RFC 6266 / 5987 (UTF-8 filenames)
    const utf8Match = /filename\*=UTF-8''(.+)/i.exec(header);
    if (utf8Match) {
      return decodeURIComponent(utf8Match[1]);
    }

    // fallback
    const asciiMatch = /filename="?([^"]+)"?/i.exec(header);
    return asciiMatch ? asciiMatch[1] || null : null;
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/calculation/calculation.component.ts